module.exports = __webpack_public_path__ + "images/home-slides/painter.09fc8b352f6bd1ee09d5b1082fcf97a0.jpg";